(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ip-redirect"]) return;
  try {
    
    function inArray(needle, haystack) {
        var length = haystack.length;
        for(var i = 0; i < length; i++) {
            if(haystack[i] == needle) return true;
        }
        return false;
    }
    function setCookie(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    function eraseCookie(name) {
        document.cookie = name+'=; Max-Age=-99999999;';
    }
    function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    var parameter = getParameterByName('redirect');
    var showCookie = getCookie('geo_located');
    var multistoreLocation = getCookie('multistoreLocation');
    multistoreLocation = null;
    let domain = window.location.host;
    
    if(multistoreLocation != null) {
        let _multistoreLocation_arr = multistoreLocation.split("://");
        _multistoreLocation_arr = _multistoreLocation_arr[1].split(".");
        _multistoreLocation_arr = _multistoreLocation_arr[0];

        let currentLocation_arr = window.location.href.split("://");
        currentLocation_arr = currentLocation_arr[1].split(".");
        currentLocation_arr = currentLocation_arr[0];
        if(!currentLocation_arr.includes(_multistoreLocation_arr)) {
            location.href = multistoreLocation;
        }
    } else {

        if(parameter == null){

                var requestUrl = window.ip_redirects_api_url;
                $.ajax({
                    url: requestUrl,
                    type: 'GET',
                    dataType: 'json',
                    success: function(response){    
                        var country_code = response.country;
                        setCookie('country_code', country_code, 7);

                        $('.header__utility .form--stores input[name="q"]').val(response.city);

                        var ip = response.ip;
                        var whitelists = window.whitelist_ips.split(",");
                        var is_in_whitelist = false;
                        if(whitelists.length > 0) {
                            for(var i = 0; i < whitelists.length;i++) {
                                if(whitelists[i] == ip) {
                                    is_in_whitelist = true;
                                }
                            }
                        }


                        var target_url = "";

                        if(!is_in_whitelist && window.ip_redirect_redirect_urls != '') {
                            var urls = window.ip_redirect_redirect_urls.split('@@');
                            var country_items = window.ip_redirect_redirect_countries.split('@@');
                            var countries = [];
                            for(var i = 0; i < country_items.length; i++) {
                                countries = country_items[i].split('|');
                                if (inArray(country_code, countries)) {
                                    target_url = urls[i];
                                }
                            }

                            setCookie('geo_located', true, 7);

                            var query_params_url = '?redirect=true';
                            if(location.search != '') {
                                query_params_url = location.search + '&redirect=true';
                            }

                            if(target_url != '') {
                                var _urls = target_url.split("//");
                                _urls = _urls[1];
                                _urls = _urls.split("/");
                                var target_domain = _urls[0];

                                if(target_domain != domain) {
                                    location.href = target_url + location.pathname + query_params_url;
                                }
                            }
                        }
                    },
                    error: function(err){
                        console.log("Request failed, error= " + err.responseText);
                    }
                });

        }
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
